// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__zxTqV","right":"styles_right__nRjUx"};